const productCardFactory = require('../shelfproduct/shelfbundle-card-factory');

module.exports = function (productGroupService, settingsService, $timeout, shopPageStateService, $stateParams, FiltersService, searchService) {
    return {
        restrict: 'E',
        scope: {
            productGroupId: '=groupId'
        },
        require: '^wowCardList',
        link(scope, element, attrs, cardListCtrl) {
            function createCards(bundles) {

                const items = searchService.transformProductsToDefault(bundles.items, true);

                cardListCtrl.updateTitle();

                return {
                    items: productCardFactory.createProductCards(items, bundles.items),
                    totalRecordCount: bundles.totalRecordCount,
                    productCollection: bundles
                };
            }

            function getCards(pageSize, pageNumber) {

                return settingsService.getSettingValue('ProductGroup', 'SortOptions')
                    .then(function (response) {
                        return response[0].Value;
                    }).then(function (sortBySetting) {
                        const args = {
                            pageNumber: pageNumber || 1,
                            pageSize: pageSize || 10,
                            sortType: $stateParams.sortby || sortBySetting,
                            filters: FiltersService.getAppliedFilters()
                        };

                        return productGroupService.selectProductGroup(scope.productGroupId)
                                                  .then(group => productGroupService.getProducts(args, group))
                                                  .then(createCards);
                    });
            }

            function getTitle() {
                return productGroupService.productGroupTitle;
            }

            cardListCtrl.setOptions({
                    getCards,
                    getTitle,
                    disablePaging: false,
                    smallerProductStampsEnabled: true,
                    updateCardsOnLogin: true
                });

            cardListCtrl.update();
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/productgroups/productgroup-products-directive.js
 **/